'use client'
import {
  Textarea
} from "./chunk-4IH3O7BJ.mjs";
export {
  Textarea
};
//# sourceMappingURL=index.mjs.map